import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-open-link-icon',
  templateUrl: './lib-open-link-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibOpenLinkIconComponent {}
